<div class="main-wrapper"><v-sheet class="pa-6 elevation-2"><AdminCompanies :companies="companies"></AdminCompanies></v-sheet></div>